(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7362],{

/***/ 12652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 17 modules
var dialog = __webpack_require__(10001);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54731);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/components/V3/Modal/Header.tsx




function Header(param) {
    var header = param.header, onClose = param.onClose, showClose = param.showClose, headerDivider = param.headerDivider;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-lg font-semibold mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                        as: "h2",
                        className: "flex-1",
                        children: header
                    }),
                    showClose ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "cursor-pointer",
                        "aria-label": "Close button",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                            size: 24
                        })
                    }) : null
                ]
            }),
            headerDivider ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 border-b border-b-gray-100 dark:border-gray-400"
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/components/V3/Modal/styles.module.css
var styles_module = __webpack_require__(76761);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/V3/Modal/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







// import {Inter} from '@next/font/google'


var shouldPreventOnClickOutside = function(canClickOutside) {
    if ((0,isServerSide/* default */.Z)()) return false;
    if (!canClickOutside) return true;
    if (document.getElementById("popup_modal_open")) {
        // This is hacky, but couldn't think of a better way to prevent the click outside when there are two modals open
        return true;
    }
    return false;
};
function Modal(props) {
    var header = props.header, children = props.children, _isOpen = props.isOpen, isOpen = _isOpen === void 0 ? true : _isOpen, _onClose = props.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _showClose = props.showClose, showClose = _showClose === void 0 ? true : _showClose, initialFocusRef = props.initialFocusRef, headerDivider = props.headerDivider, footer = props.footer, _popFromBottom = props.popFromBottom, popFromBottom = _popFromBottom === void 0 ? true : _popFromBottom, _hasHeightLimit = props.hasHeightLimit, hasHeightLimit = _hasHeightLimit === void 0 ? false : _hasHeightLimit, _forceJustoFont = props.forceJustoFont, forceJustoFont = _forceJustoFont === void 0 ? false : _forceJustoFont, _compact = props.compact, compact = _compact === void 0 ? false : _compact, _canClickOutside = props.canClickOutside, canClickOutside = _canClickOutside === void 0 ? true : _canClickOutside, _highZIndex = props.highZIndex, highZIndex = _highZIndex === void 0 ? false : _highZIndex;
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var zIndex = highZIndex ? " z-[110000]" : "z-[1100]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: (0,classnames/* default */.Z)("relative", zIndex),
            initialFocus: initialFocusRef,
            onClose: function() {
                if (!shouldPreventOnClickOutside(canClickOutside)) {
                    onClose();
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classnames/* default */.Z)("fixed inset-0 overflow-y-auto", {
                        dark: isDarkMode
                    }, zIndex),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,classnames/* default */.Z)("flex sm:items-center justify-center min-h-[100dvh] text-center p-0", {
                            "items-end": popFromBottom,
                            "items-center": !popFromBottom
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-1100",
                            enterFrom: "opacity-0 translate-y-8 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-8 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: (0,classnames/* default */.Z)((styles_module_default()).modal, _defineProperty({
                                    "relative rounded-t-lg md:rounded-lg text-left shadow-xl transform transition-all sm:my-8 w-full text-black": true,
                                    "sm:max-w-lg": !compact,
                                    "sm:max-w-md": compact,
                                    "bg-white text-black": !isDarkMode,
                                    "bg-gray-800 text-white": isDarkMode,
                                    "rounded-lg mx-4 max-w-[90vw]": !popFromBottom,
                                    "font-sans": forceJustoFont
                                }, props.className, !!props.className)),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "v3_modal",
                                        className: (0,classnames/* default */.Z)({
                                            "px-4 md:px-5": !compact,
                                            "pt-5 md:pt-6": true,
                                            "pb-5 md:pb-6": !footer,
                                            "pb-0 md:pb-0": !!footer
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,classnames/* default */.Z)({
                                                    "px-4 md:px-5": compact
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                    header: header,
                                                    onClose: onClose,
                                                    showClose: showClose,
                                                    headerDivider: headerDivider
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: hasHeightLimit ? (0,classnames/* default */.Z)({
                                                    "overflow-y-auto": true,
                                                    "max-h-[80vh]": !footer,
                                                    "max-h-[70vh]": !!footer
                                                }) : "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                                                    children: children
                                                })
                                            })
                                        ]
                                    }),
                                    footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: footer
                                    }) : null
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 94279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18899);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






function Pill(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, children = props.children, outline = props.outline, _caretDirection = props.caretDirection, caretDirection = _caretDirection === void 0 ? "down" : _caretDirection, _square = props.square, square = _square === void 0 ? false : _square, _big = props.big, big = _big === void 0 ? false : _big, _small = props.small, small = _small === void 0 ? false : _small, _primary = props.primary, primary = _primary === void 0 ? false : _primary, _showCaret = props.showCaret, showCaret = _showCaret === void 0 ? true : _showCaret, _loading = props.loading, loading = _loading === void 0 ? false : _loading;
    var isDarkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var style = outline ? "outline" : primary ? "primary" : isDarkMode ? "dark" : "default";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_defineProperty({
            "inline-flex text-sm border-2 items-center transition ease-in-out duration-150": true,
            "!text-xs h-8": small,
            "bg-gray-100 text-gray-700 border-gray-100": style === "default",
            "bg-gray-600 text-white border-gray-600": style === "dark",
            "cursor-pointer": !loading,
            "hover:bg-gray-200 hover:border-gray-200": !loading && style === "default",
            "hover:bg-gray-300 hover:border-gray-300": !loading && style === "dark",
            "bg-transparent border-gray-100": style === "outline",
            "border-gray-600 !border": style === "outline" && isDarkMode,
            "hover:bg-gray-100": !loading && style === "outline",
            "button-v3-primary focus:button-v3-primary text-white border-0": style === "primary",
            "rounded-full": !square,
            "rounded-md": square,
            "px-4": !!children,
            "px-[2px] py-0": !children,
            "py-0": !big && !!children,
            "py-2": big
        }, className, true)),
        onClick: function() {
            if (loading) return;
            onClick();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-1 font-semibold",
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-gray-300"
                }) : children
            }),
            showCaret ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                    "flex items-start flex-col transition ease-in-out duration-300": true,
                    "ml-1": !!children,
                    "transform rotate-0": caretDirection === "down",
                    "transform rotate-180": caretDirection === "up",
                    "transform rotate-90": caretDirection === "left",
                    "transform rotate-[-90deg]": caretDirection === "right"
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[2px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdKeyboardArrowDown */ .Ix0, {
                        size: small ? 20 : 24
                    })
                ]
            }) : null
        ]
    });
};


/***/ }),

/***/ 98397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ setReactGA; },
/* harmony export */   "Z": function() { return /* binding */ getReactGA; }
/* harmony export */ });
var ReactGA = null;
var setReactGA = function(reactGA) {
    ReactGA = reactGA;
};
var getReactGA = function() {
    return ReactGA;
};


/***/ }),

/***/ 31765:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dropOffTypeLabels = {
    meetAtDoor: "Encontrarse en la puerta",
    meetOutside: "Encontrarse afuera",
    leaveAtDoor: "Dejar el paquete en conserjer\xeda o en la puerta si es una casa"
};
/* harmony default export */ __webpack_exports__["Z"] = (dropOffTypeLabels);


/***/ }),

/***/ 14726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trackPageView; }
/* harmony export */ });
/* harmony import */ var _helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98397);
/* harmony import */ var _helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55985);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13241);



function trackPageView(pathname) {
    var pixel = (0,_helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    if (!pathname.includes("/virtual")) {
        pixel === null || pixel === void 0 ? void 0 : pixel.pageView();
    }
    var ReactGA = (0,_helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__/* .getReactGA */ .Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(pathname);
    if (ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isInitialized */ .ZP.isInitialized()) {
        var ga4 = ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGA4React */ .ZP.getGA4React();
        if (ga4) {
            ga4.pageview(pathname);
        }
    }
};


/***/ }),

/***/ 55870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ECOMMERCE_EVENTS; },
  "Z": function() { return /* binding */ useTrackEcommerceEvent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/hooks/useCookiesAccepted.ts
var useCookiesAccepted = __webpack_require__(35756);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/ga-4-react/dist/ga-4-react.esm.js
var ga_4_react_esm = __webpack_require__(13241);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/sendEcommerceEventMutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation sendEcommerceEvent(\n    $eventName: String\n    $eventIdentifier: String\n    $actionSource: String\n    $orderId: ID\n    $currency: String\n    $items: [JSON]\n    $totalPrice: Float\n    $origin: String\n    $customParams: JSON\n  ) {\n    sendEcommerceEvent(\n      eventName: $eventName\n      eventIdentifier: $eventIdentifier\n      actionSource: $actionSource\n      orderId: $orderId\n      currency: $currency\n      items: $items\n      totalPrice: $totalPrice\n      origin: $origin\n      customParams: $customParams\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var sendEcommerceEventMutation = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/helpers/getReactGA.ts
var getReactGA = __webpack_require__(98397);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/helpers/getReactPixel.ts
var getReactPixel = __webpack_require__(55985);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var providers = {
    GA4: "ga4",
    PIXEL: "pixel",
    GTM: "gtm"
};
var pixelSendEvent = function(eventName, data, eventExtraData) {
    var reactPixel = (0,getReactPixel/* default */.Z)();
    reactPixel === null || reactPixel === void 0 ? void 0 : reactPixel.fbq("track", eventName, data, eventExtraData);
};
var recommendedEvents = {
    ADD_TO_CART: {
        pixel: "AddToCart",
        ga4: "add_to_cart",
        gtm: "add_to_cart"
    },
    BEGIN_CHECKOUT: {
        pixel: "InitiateCheckout",
        ga4: "begin_checkout",
        gtm: "begin_checkout"
    },
    PURCHASE: {
        pixel: "Purchase",
        ga4: "purchase",
        gtm: "purchase"
    },
    SELECT_ITEM: {
        ga4: "select_item",
        gtm: "select_item"
    }
};
var ga4SendEvent = function(action, additionalData) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, label = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, category = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, nonInteraction = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if ((0,isServerSide/* default */.Z)()) return;
    var isInitialized = ga_4_react_esm/* default.isInitialized */.ZP.isInitialized();
    if (!isInitialized) {
        return;
    }
    var ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
    if (!ga4) {
        logger/* default.warn */.Z.warn("Could not get GA4React");
        return;
    }
    var data = _objectSpread({}, additionalData);
    if (custom) {
        data = _objectSpread({}, data, {
            event_label: label,
            event_category: category,
            nonInteraction: nonInteraction
        });
    }
    ga4.gtag("event", action, data);
};
var gtmSendEvent = function(dataLayer) {
    dist_default().dataLayer({
        dataLayer: dataLayer
    });
};
var analyticsEventManager = {
    pixel: pixelSendEvent,
    ga4: ga4SendEvent,
    gtm: gtmSendEvent
};

// EXTERNAL MODULE: ./src/helpers/track/trackPageView.ts
var trackPageView = __webpack_require__(14726);
;// CONCATENATED MODULE: ./src/helpers/track/trackAddToCart.ts




function trackAddToCart(param, param1) {
    var product = param.product, item = param.item, amount = param.amount, eventId = param1.eventId;
    if (!product || !item) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    var currency = (0,getCurrencyCode/* default */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
        id: product._id,
        name: product.name,
        price: item.unitPrice,
        category: product.categories.length ? product.categories[0].internalName : null,
        quantity: amount,
        currency: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "add");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.event({
        category: "UX",
        action: "addProductToCart",
        label: "Agregar al carro"
    });
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id,
        value: item.unitPrice,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.ADD_TO_CART.pixel, pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: item.unitPrice,
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                price: item.unitPrice,
                quantity: amount
            }
        ]
    };
    analyticga4SendEvent(recommendedEvents.ADD_TO_CART.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.ADD_TO_CART.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name,
                    price: item.unitPrice,
                    quantity: amount
                }
            ]
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/add_to_cart");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackInitCheckout.ts



function trackInitCheckout(param, param1) {
    var cart = param.cart, eventId = param1.eventId;
    if (!cart) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "checkout");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview("/checkout");
    var currency = (0,getCurrencyCode/* default */.Z)();
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var numItems = cart.items.reduce(function(sum, item) {
        return item.amount + sum;
    }, 0);
    var pixelData = {
        value: cart.itemsPrice,
        num_items: numItems,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.BEGIN_CHECKOUT.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(cart.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: cart.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.BEGIN_CHECKOUT.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.BEGIN_CHECKOUT.gtm,
        ecommerce: {
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
};

;// CONCATENATED MODULE: ./src/helpers/track/trackProductView.ts
function trackProductView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function trackProductView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            trackProductView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function trackProductView(param, param1) {
    var product = param.product, eventId = param1.eventId;
    if (!product) return;
    if (!product.availabilityAt) return;
    var finalPrice = product.availabilityAt.finalPrice;
    var currencyCode = (0,getCurrencyCode/* default */.Z)();
    var gaData = {
        id: product._id,
        name: product.name,
        category: product.categories.length ? product.categories[0].internalName : null
    };
    var ga4Data = {
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                category: product.categories.length ? product.categories[0].internalName : null,
                currency: currencyCode
            }
        ]
    };
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id
    };
    var gtmData = {
        event: recommendedEvents.SELECT_ITEM.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name
                }
            ]
        }
    };
    if (finalPrice) {
        pixelData = trackProductView_objectSpread({}, pixelData, {
            value: finalPrice,
            currency: currencyCode
        });
        ga4Data["items"] = [
            trackProductView_objectSpread({}, ga4Data["items"][0], {
                price: finalPrice
            })
        ];
        gtmData["ecommerce"]["items"] = [
            trackProductView_objectSpread({}, gtmData["ecommerce"]["items"][0], {
                price: finalPrice
            })
        ];
        gaData = trackProductView_objectSpread({}, gaData, {
            price: finalPrice
        });
    }
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currencyCode
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addImpression", gaData);
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "detail");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    analyticPixelSendEvent("ViewContent", pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    analyticga4SendEvent(recommendedEvents.SELECT_ITEM.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/view_content");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackPurchase.ts




function trackPurchase(param, param1) {
    var order = param.order, eventId = param1.eventId;
    if (!order) return;
    var currency = (0,getCurrencyCode/* default */.Z)();
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "clear", {});
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = order.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
                id: item.product._id,
                name: item.product.name,
                category: item.product.categories.length ? item.product.categories[0].internalName : null,
                price: item.unitPrice,
                quantity: item.amount
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "purchase", {
        id: order._id,
        revenue: order.totalPrice,
        coupon: order.couponCode,
        shipping: order.deliveryFee
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        value: order.totalPrice,
        num_items: order.totalItems,
        currency: currency,
        content_type: "product",
        content_ids: Array.from(order.items.map(function(item) {
            return item.product._id;
        }))
    };
    analyticPixelSendEvent(recommendedEvents.PURCHASE.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(order.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            item_category: item.product.categories.length ? item.product.categories[0].internalName : null,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        transaction_id: order._id,
        value: order.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.PURCHASE.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.PURCHASE.gtm,
        ecommerce: {
            currency: currency,
            transaction_id: order._id,
            value: order.totalPrice,
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/purchase");
};

;// CONCATENATED MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useTrackEcommerceEvent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useTrackEcommerceEvent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useTrackEcommerceEvent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ECOMMERCE_EVENTS;
(function(ECOMMERCE_EVENTS) {
    ECOMMERCE_EVENTS["PAGEVIEW"] = "PageView";
    ECOMMERCE_EVENTS["VIEWCONTENT"] = "ViewContent";
    ECOMMERCE_EVENTS["INITCHECKOUT"] = "InitiateCheckout";
    ECOMMERCE_EVENTS["ADDTOCART"] = "AddToCart";
    ECOMMERCE_EVENTS["PURCHASE"] = "Purchase";
})(ECOMMERCE_EVENTS || (ECOMMERCE_EVENTS = {}));
function gtag(ga4, method, ga4Code, value) {
    return _gtag.apply(this, arguments);
}
function _gtag() {
    _gtag = _asyncToGenerator(runtime_default().mark(function _callee(ga4, method, ga4Code, value) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        ga4.gtag(method, ga4Code, value, function(result) {
                            resolve(result);
                        });
                        setTimeout(function() {
                            reject("timeout");
                        }, 1000);
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _gtag.apply(this, arguments);
}
function customParamsToEvent(initialData) {
    return _customParamsToEvent.apply(this, arguments);
}
function _customParamsToEvent() {
    _customParamsToEvent = /**
 * Based on the data required for GA4 Measurement protocol https://developers.google.com/analytics/devguides/collection/protocol/ga4?hl=es
 * @param initialData
 * @returns {Promise<{clientId: string, sessionId: string}>}
 */ _asyncToGenerator(runtime_default().mark(function _callee(initialData) {
        var ref, ref1, customParams, ga4Code, ga4, clientId, sessionId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    customParams = {};
                    ga4Code = (ref = initialData.integrations) === null || ref === void 0 ? void 0 : (ref1 = ref.integrations) === null || ref1 === void 0 ? void 0 : ref1.googleAnalyticsV4Id;
                    if (!(ga4Code && ga_4_react_esm/* default.isInitialized */.ZP.isInitialized())) {
                        _ctx.next = 15;
                        break;
                    }
                    ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
                    if (ga4) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", customParams);
                case 7:
                    _ctx.next = 9;
                    return gtag(ga4, "get", ga4Code, "client_id");
                case 9:
                    clientId = _ctx.sent;
                    customParams["clientId"] = clientId;
                    _ctx.next = 13;
                    return gtag(ga4, "get", ga4Code, "session_id");
                case 13:
                    sessionId = _ctx.sent;
                    customParams["sessionId"] = sessionId;
                case 15:
                    return _ctx.abrupt("return", customParams);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _customParamsToEvent.apply(this, arguments);
}
function serverSendEvent(eventName, mutate, data, initialData) {
    return _serverSendEvent.apply(this, arguments);
}
function _serverSendEvent() {
    _serverSendEvent = _asyncToGenerator(runtime_default().mark(function _callee(eventName, mutate, data, initialData) {
        var orderId, eventId, source, items, currency, totalPrice, variables, customParams;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (mutate) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    orderId = data.orderId, eventId = data.eventId, source = data.source, items = data.items, currency = data.currency, totalPrice = data.totalPrice;
                    variables = useTrackEcommerceEvent_objectSpread({
                        eventName: eventName,
                        eventIdentifier: eventId,
                        currency: currency,
                        totalPrice: totalPrice,
                        actionSource: source,
                        origin: "web"
                    }, items && {
                        items: items
                    }, orderId && {
                        orderId: orderId
                    });
                    _ctx.next = 7;
                    return customParamsToEvent(initialData);
                case 7:
                    customParams = _ctx.sent;
                    variables["customParams"] = customParams;
                    _ctx.next = 11;
                    return mutate({
                        mutation: sendEcommerceEventMutation,
                        variables: variables
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    logger/* default.warn */.Z.warn("could not send event to ecommerceEvents", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _serverSendEvent.apply(this, arguments);
}
function useTrackEcommerceEvent() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var initialData = (0,useInitialData/* default */.Z)();
    var cookies = (0,useCookiesAccepted/* default */.Z)();
    var trackEcommerceEvent = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event1, params1) {
            var getEventServerData, serverData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getEventServerData = function _getEventServerData(event, params) {
                            var eventId = (0,v4/* default */.Z)();
                            var currency = (0,getCurrencyCode/* default */.Z)();
                            var baseData = {
                                currency: currency,
                                eventId: eventId,
                                source: location.origin
                            };
                            if (event === ECOMMERCE_EVENTS.PAGEVIEW) {
                                if (cookies) (0,trackPageView/* default */.Z)(params);
                                return null;
                            }
                            if (event === ECOMMERCE_EVENTS.VIEWCONTENT) {
                                if (cookies) trackProductView(params, {
                                    eventId: eventId
                                });
                                var product = params.product;
                                if (!product) return null;
                                var items = [
                                    {
                                        id: product._id,
                                        quantity: 1,
                                        itemPrice: product.value,
                                        itemName: product.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items,
                                    totalPrice: product.value
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.INITCHECKOUT) {
                                if (cookies) trackInitCheckout(params, {
                                    eventId: eventId
                                });
                                var cart = params.cart;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: Array.from(cart.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    })),
                                    totalPrice: cart.itemsPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.ADDTOCART) {
                                if (cookies) trackAddToCart(params, {
                                    eventId: eventId
                                });
                                var product1 = params.product, amount = params.amount, item1 = params.item;
                                if (!product1) return null;
                                var items1 = [
                                    {
                                        id: product1._id,
                                        quantity: amount,
                                        itemPrice: item1.unitPrice,
                                        itemName: product1.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items1,
                                    totalPrice: item1.totalPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.PURCHASE) {
                                if (cookies) trackPurchase(params, {
                                    eventId: eventId
                                });
                                var order = params.order;
                                if (!order) return null;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    orderId: order._id,
                                    totalPrice: order.totalPrice
                                }, order.items && {
                                    items: Array.from(order.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    }))
                                });
                            }
                            return null;
                        };
                        _ctx.prev = 1;
                        ;
                        serverData = getEventServerData(event1, params1);
                        if (serverData) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return serverSendEvent(event1, mutate, serverData, initialData);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        logger/* default.warn */.Z.warn("error useTrackEcommerceEvent", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function trackEcommerceEvent(event1, params1) {
            return _ref.apply(this, arguments);
        };
    }();
    return trackEcommerceEvent;
};


/***/ }),

/***/ 13505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExperiment; }
/* harmony export */ });
/* unused harmony export withExperiment */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32321);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90257);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var _useUserId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77883);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getUserExperimentBranch(\n        $experimentId: String!\n        $deviceId: String!\n        $websiteId: String\n        $userId: String\n        $countryCode: String\n      ) {\n        getUserExperimentBranch(\n          experimentId: $experimentId\n          websiteId: $websiteId\n          userId: $userId\n          deviceId: $deviceId\n          countryCode: $countryCode\n        ) {\n          branchName\n          createdAt\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function useExperiment(experimentId) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _partial = ref.partial, partial = _partial === void 0 ? true : _partial;
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().website;
    var deviceId = (0,_helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var userId = (0,_useUserId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    // Hacky trick to disable apollo validation since this uses the experiments client
    var getUserExperimentBranch = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useApolloQuery */ .Zu)({
        errorPolicy: "ignore",
        clientName: "experiments",
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: {
            experimentId: experimentId,
            websiteId: website === null || website === void 0 ? void 0 : website._id,
            userId: userId,
            deviceId: deviceId,
            countryCode: website === null || website === void 0 ? void 0 : website.countryCode
        },
        partial: partial,
        fetchPolicy: "cache-first",
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)() || !experimentId
    }).getUserExperimentBranch;
    return getUserExperimentBranch === null || getUserExperimentBranch === void 0 ? void 0 : getUserExperimentBranch.branchName;
};
var withExperiment = function(experimentId, Component) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        var branchName = useExperiment(experimentId);
        return /*#__PURE__*/ _jsx(Component, _objectSpread({}, props, {
            experimentBranchName: branchName
        }));
    };
};


/***/ }),

/***/ 69347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScreenSize; }
/* harmony export */ });
/* harmony import */ var _useWidth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9177);

function useScreenSize() {
    var width = (0,_useWidth__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
    // Using Tailwind breakpoints and semantics
    if (width < 640) return "mobile";
    if (width < 768) return "sm";
    if (width < 1024) return "md";
    if (width < 1280) return "lg";
    if (width < 1536) return "xl";
    return "2xl";
};


/***/ }),

/***/ 66767:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    es_CL: "CLP",
    es_MX: "MXN",
    es_PE: "PEN",
    es_CO: "COP",
    en_US: "USD",
    es_EC: "USD",
    es_CR: "CRC",
    es_AR: "ARS"
});


/***/ }),

/***/ 78263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formatNumber; }
});

// EXTERNAL MODULE: ./src/i18n/formatNumber/registerLocales.ts + 1 modules
var registerLocales = __webpack_require__(66385);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/i18n/formatNumber/currencyCodes.ts
var currencyCodes = __webpack_require__(66767);
;// CONCATENATED MODULE: ./src/i18n/formatNumber/moneyFormats.ts
/* harmony default export */ var moneyFormats = ({
    es_CL: "$0,0.[00]",
    es_MX: "$0,0.00",
    es_PE: "$0,0.00",
    es_CO: "$0,0.[00]",
    en_US: "$0,0.00",
    es_EC: "$0,0.00",
    es_CR: "$0,0.[00]",
    es_AR: "$0,0.[00]"
});

;// CONCATENATED MODULE: ./src/i18n/formatNumber/index.ts




function formatNumber(number, format, locale, removeSymbolPreffix) {
    locale = locale || __webpack_require__.g.currentLocale || "es_CL";
    (0,registerLocales/* default */.Z)(locale ? [
        locale
    ] : []);
    var numeralFormat = format;
    if (format === "money" || format === "moneyCode") {
        numeralFormat = moneyFormats[locale] || moneyFormats.es_CL;
    }
    if (numeralFormat === "0,0%") {
        numeralFormat = "0,0.[00]%";
    }
    var prevLocale = (numeral_default()).options.currentLocale;
    if (prevLocale !== locale) {
        numeral_default().locale(locale);
    }
    var numeralFormatCurrency = removeSymbolPreffix ? numeralFormat.replace("$", "") : numeralFormat;
    var result = numeral_default()(number).format(numeralFormatCurrency);
    if (prevLocale !== locale) {
        numeral_default().locale(prevLocale);
    }
    if (format === "moneyCode") {
        return "".concat(result, " ").concat(currencyCodes/* default */.Z[locale]);
    } else {
        return result;
    }
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetCurrencyCode; }
/* harmony export */ });
/* harmony import */ var _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66767);

function GetCurrencyCode() {
    var locale = __webpack_require__.g.currentLocale || "es_CL";
    return _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[locale];
};


/***/ }),

/***/ 76761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1AYmWIGgwz0X4u6OD96Lss"};

/***/ })

}]);